import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import { redirectToOriginSubdomain } from "@/modules/origin-redirect-utils";
const amplifyConfig = JSON.parse(JSON.stringify(awsconfig)); // or structuredClone(awsExports)
Amplify.configure(amplifyConfig);

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({domain: 'bankszamlakivonat.hu'}));

//cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({domain: 'lvh.me',secure: false}));
import { fetchAuthSession, getCurrentUser } from "@aws-amplify/auth";

async function restoreAuth() {
  try {
    // Force Amplify to load tokens from cookies/localStorage
    const session = await fetchAuthSession();
    if (session?.tokens?.idToken) {
      console.log("✅ Session restored:", session);
      const user = await getCurrentUser();
      console.log("✅ User restored:", user);
    } else {
      console.warn("⚠️ No session found in cookies");
    }
  } catch (err) {
    console.error("❌ Failed to restore auth session", err);
  }
}

await restoreAuth();

import config from "./config";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import vsm from "./modules/vsm/src/index";

import AsyncComputed from "vue-async-computed";
// import { MqttOverWSProvider } from "@aws-amplify/pubsub/lib/Providers";
import Toasted from "vue-toasted";
import VueCookie from "vue-cookie";
import VueGtag from "vue-gtag";

import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "./scss/styles.scss";
import VueFormulate from '@braid/vue-formulate';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import Notifications from 'vue-notification'

Vue.config.productionTip = false;
Vue.use(AsyncComputed);
Vue.use(vsm.plugin, store);

Vue.use(VueToast, { position: "bottom-right", duration: "6000", type: "success"});
Vue.use(Toasted, { theme: "bubble" });
Vue.use(Notifications);
Vue.use(VueCookie);
sessionStorage.setItem("initialFullUrl", window.location.href);

const statisticalCookiesEnabled = Vue.cookie.get("statistical") ? true : false;

Vue.use(VueGtag, {
  config: { id: "G-QTKHWT5X2J" },
  bootstrap: statisticalCookiesEnabled,
}, router);


if (!statisticalCookiesEnabled) {
  Vue.cookie.delete("_ga_QTKHWT5X2J", {domain: "." + window.location.hostname});
}

Vue.use(VueFormulate);
new Vue({
  
  router,
  store,
  vuetify,
  render: (h) => h(App, { props: { config } }),
}).$mount("#app");
await redirectToOriginSubdomain();
